export default "__VITE_ASSET__420511c4__"